import { canUseDOM, cookie } from '@pmi/pmi-iqos-shared-react'
import accounting from 'accounting'
import striptags from 'striptags'

const noop = () => {}
const unformatPrice = n => accounting.unformat(n)
const sanitizeHtml = s => striptags(s)

const ZYN_BRAND = 'Zyn'

export class ZynAnalyticsManager {
  constructor(dataLayer) {
    this.dataLayer = dataLayer || []
  }

  threeDSResult = success => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      eventCategory: 'Checkout',
      eventLabel: `3D Secure - Payment ${success ? 'Success' : 'Failure'}`,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  productListFilterSelect = filterValue => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'productListFilterSelect',
      brand: ZYN_BRAND,
      ProductListFilterSelectOption: filterValue,
      eventAction: 'Click',
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  viewCart = cartItems => {
    const dataLayer = this.dataLayer

    const products =
      cartItems?.length > 0
        ? [].concat.apply(
            [],
            cartItems.map(item => item.products)
          )
        : []

    const mappedProducts = products?.map(product => {
      return {
        name: product.name ? sanitizeHtml(product.name) : '',
        id: product.id,
        price: unformatPrice(product.price),
        brand: ZYN_BRAND,
        category: sanitizeHtml(product.category),
        variant: product.options[product.selectedOptionIndex]?.variantId
      }
    })
    const data = {
      event: 'viewCart',
      ecommerce: {
        currencyCode: 'JPY',
        view: {
          products: mappedProducts
        }
      },
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  toastPopUp = label => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      brand: ZYN_BRAND,
      eventCategory: 'Toast Pop Up',
      eventAction: 'Click',
      eventLabel: label,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  addToCartErrorPopupDisplay = popupTitle => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'popupDisplay',
      brand: ZYN_BRAND,
      popupDisplayContent: popupTitle,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  addToCartErrorPopupClick = (popupTitle, optionSelected) => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'popupClick',
      brand: ZYN_BRAND,
      popupDisplayContent: popupTitle,
      popupDisplayOption: optionSelected,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  checkoutTvaClickUpload = (uploaded, type) => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      brand: ZYN_BRAND,
      eventAction: 'Click',
      eventCategory: 'Age Verification',
      eventLabel: uploaded
        ? type === 'front'
          ? 'Upload ID - Front - Success'
          : 'Upload ID - Back - Success'
        : type === 'front'
        ? 'Upload ID - Front'
        : 'Upload ID - Back',
      user_id: cookie.getSpiceId() || ''
    }
    dataLayer ? dataLayer.push(data) : noop()
  }

  deliveryTimeClick = () => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      brand: ZYN_BRAND,
      eventAction: 'Click',
      eventCategory: 'Delivery Time',
      eventLabel: 'Delivery Time Impression',
      user_id: cookie.getSpiceId() || ''
    }
    dataLayer ? dataLayer.push(data) : noop()
  }
}

export default new ZynAnalyticsManager(canUseDOM ? window.dataLayer : null) // set by google tag manager
